import PropTypes from 'prop-types';
import cx from 'classnames';
import { Fragment, useState, useCallback, useRef } from 'react';

import withTheme from 'core/hocs/withTheme';

import { Mobile, Desktop } from 'core/components/breakpoint';

import withBindProps from 'core/hocs/withBindProps';
import Drum from 'core/components/Drum';
import SmartImage from 'core/components/SmartImage';
import Dropdown from 'core/components/Dropdown';
import Modal from 'core/components/Modal';
import ThemeSwitch from 'core/components/ThemeSwitch';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';
import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';

import Question from 'core/components/Icon/Question';

import ModalWindow from '../ModalWindow';
import Progressbar from '../Progressbar';
import GoToListBtn from '../GoToListBtn';

import { PAIR_COMPARE } from '../../constants';

import fifty from '../../images/fifty.png';

import styles from './index.styl';


const dropdownProps = {
  showIcon: false,
  contentBorderRadius: '12px',
  contentPadding: '20px',
  trigger: 'click',
  contentPosition: 'center',
  contentPositionY: 'top',
  className: styles.dropdown,
};


function List(props) {
  const {
    theme: {
      controls: {
        gameCompare: {
          leaderBoard: leaderBoardAtoms,
        },
      },
    },
    variants,
    active,
    isWinnerPage,
    topics,
    link,
    startIndex,
    widgetType,
    isOdd,
  } = props;

  const [isOpenedFinal, setOpenedFinal] = useState(false);
  const [isOpenedDefault, setOpenedDefault] = useState(false);
  const  closeFinal = useRef(null);
  const closeDefault = useRef(null);
  const isPairCompareWidget = widgetType === PAIR_COMPARE;

  const { card: CompareCard } = leaderBoardAtoms;

  const scopedStyles = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .modalWindow
          border-radius 12px
          padding 20px
          overflow hidden
        .closeContainer
          top 10px
          right 20px
          z-index 10
        .closeIcon
          width 10px
          height 10px
      `}</style>
    </scope>
  );

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.question}
          background ${leaderBoardAtoms.header.questionBackground}
        .headerText
          color ${leaderBoardAtoms.header.color}
          font ${leaderBoardAtoms.header.font}
          text-transform ${leaderBoardAtoms.header.textTransform}
      `}</style>
    </scope>
  );

  const handleClose = useCallback(() => {
    closeDefault.current();
    closeFinal.current();
  }, [closeDefault, closeFinal]);

  const handleInstanceDefault = useCallback((instance) => {
    closeDefault.current = instance.close;
  }, []);

  const handleInstanceFinal = useCallback((instance) => {
    closeFinal.current = instance.close;
  }, []);

  if (!variants?.length) return null;

  const titleFinal = (
    <div className={styles.info}>
      {isPairCompareWidget &&
        <span className={scope.wrapClassNames('headerText')}>Процент побед</span>
      }
      {!isPairCompareWidget && (
        <Fragment>
          <span className={scope.wrapClassNames('headerText')}>Победил в&nbsp;финале</span>
          <div className={scope.wrapClassNames(styles.question)}>
            <Question fill={leaderBoardAtoms.header.questionFill} />
          </div>
        </Fragment>
      )}
    </div>
  );

  const titleDefault = (
    <div className={styles.info}>
      <span className={scope.wrapClassNames('headerText')}>
        <Desktop>Победил 1&nbsp;VS&nbsp;1</Desktop>
        <Mobile>Победил 1:1</Mobile>
      </span>
      <div className={scope.wrapClassNames(styles.question)}>
        <Question fill={leaderBoardAtoms.header.questionFill} />
      </div>
    </div>
  );

  const modalWindowFinal = (
    <ModalWindow
      title='Победил&nbsp;в&nbsp;финале'
      text='Количество&nbsp;финальных&nbsp;побед&nbsp;/&nbsp;общее количество игр'
      handleClose={handleClose}
    />
  );

  const modalWindowDefault = (
    <ModalWindow
      title='Победил 1 vs 1'
      text='Количество&nbsp;побед&nbsp;/&nbsp;общее&nbsp;количество матчей 1:1'
      handleClose={handleClose}
    />
  );

  return (
    <ol
      className={cx(
        styles.list,
        active === 0 && '_first',
        !isWinnerPage && styles._allList)}
    >
      <style jsx>{`
        .${styles.list}
          border 1px solid ${leaderBoardAtoms.table.borderColor}
          background ${leaderBoardAtoms.table.background}

        .${styles.variant}
          border-bottom 1px solid ${leaderBoardAtoms.table.borderColor}
          &._active
            background ${leaderBoardAtoms.table.activeBackground}
            :global(.mobile) &
              border-bottom 1px solid ${leaderBoardAtoms.table.borderColor}
          &:last-child
          :global(.mobile) &
            border-bottom none
            &.${styles._header}
              border-bottom 1px solid ${leaderBoardAtoms.table.borderColor}

        .${styles.drum}
          :global(.desktop) &
            border-bottom 1px solid ${leaderBoardAtoms.table.borderColor}

        .${styles.count}
          color ${leaderBoardAtoms.count.color}
          font ${leaderBoardAtoms.count.font}
          ._top &
            background ${leaderBoardAtoms.count.background}
          ._active &
            color ${leaderBoardAtoms.count.activeColor}
            background ${leaderBoardAtoms.count.activeBackground}
          :global(.mobile) &
            background ${leaderBoardAtoms.count.background}

        .${styles.caption}
          font ${leaderBoardAtoms.caption}

        .${styles.draw}
          background ${leaderBoardAtoms.draw.background}
      `}</style>
      <li className={cx(styles.variant, styles._header)}>
        <div className={styles.col}>
          <div className={scope.wrapClassNames('headerText', styles.position)}>
            <Desktop>Позиция в рейтинге</Desktop>
            <Mobile>#</Mobile>
          </div>
        </div>
        <div className={styles.col}>
          <Desktop>
            <ThemeSwitch name={leaderBoardAtoms.dropdown.theme}>
              {isPairCompareWidget ?
                titleFinal
                : (
                  <Dropdown
                    anchor={titleFinal}
                    getInstance={handleInstanceFinal}
                    {...dropdownProps}
                  >
                    {modalWindowFinal}
                  </Dropdown>
                )
              }
            </ThemeSwitch>
          </Desktop>

          <Mobile>
            <div onClick={() => setOpenedFinal(prev => !prev)}>
              {titleFinal}
            </div>
            <Modal
              isOpen={isOpenedFinal}
              onClose={() => setOpenedFinal(false)}
              scopedStyles={scopedStyles}
            >
              {modalWindowFinal}
            </Modal>
          </Mobile>
        </div>

        {!isPairCompareWidget && (
          <div className={styles.col}>
            <Desktop>
              <ThemeSwitch name={leaderBoardAtoms.dropdown.theme}>
                <Dropdown
                  anchor={titleDefault}
                  getInstance={handleInstanceDefault}
                  {...dropdownProps}
                >
                  {modalWindowDefault}
                </Dropdown>
              </ThemeSwitch>
            </Desktop>

            <Mobile>
              <div onClick={() => setOpenedDefault(prev => !prev)}>
                {titleDefault}
              </div>
              <Modal
                isOpen={isOpenedDefault}
                onClose={() => setOpenedDefault(false)}
                scopedStyles={scopedStyles}
              >
                {modalWindowDefault}
              </Modal>
            </Mobile>
          </div>
        )}
      </li>
      {
        variants.map((variant, i) => {
          if ((isOdd && i === variants.length - 1) && isPairCompareWidget) return null;

          const {
            attributes: {
              caption,
              image,
            },
            default: defaultReaction,
            final,
          } = variant;

          const originalCover = image?.attributes?.versions?.original;
          const previewCover = image?.attributes?.versions?.thumbnail;

          const isActive = i === active;

          return (
            <Fragment key={variant.id}>
              <li className={cx(
                styles.variant,
                (i < 3) && '_top',
                isActive && '_active')}
              >
                <div className={styles.col}>
                  <div className={styles.count}>
                    {startIndex + i + 1}
                  </div>
                  {(!isPairCompareWidget || caption) && (
                    <div className={styles.image}>
                      <SmartImage
                        src={originalCover}
                        previewSrc={previewCover}
                        aspectRatio={1}
                        maxWidth={80}
                      />
                    </div>
                  )}
                  {isPairCompareWidget && !caption && (
                    <div className={styles.draw}>
                      <SmartImage
                        url={fifty}
                        maxWidth={80}
                        aspectRatio={1}
                        placement='contain'
                      />
                    </div>
                  )}
                  <Desktop>
                    <div className={styles.caption}>{caption || 'Ничья'}</div>
                  </Desktop>
                </div>
                <div className={styles.col}>
                  <Mobile>
                    <div className={styles.caption}>{caption || 'Ничья'}</div>
                  </Mobile>
                  <Progressbar percent={final} active={isActive}  />
                </div>
                {!isPairCompareWidget && (
                  <div className={styles.col}>
                    <Progressbar
                      percent={defaultReaction}
                      type='default'
                      active={isActive}
                    />
                  </div>
                )}
              </li>

              {(!isWinnerPage && topics?.length > 0 && i === 4) && CompareCard &&
                <li className={styles.drum}>
                  <Drum
                    content={topics}
                    card={withBindProps({ leaderBoardCard: true })(CompareCard)}
                    itemWidth='100%'
                    itemWidthMobile='100%'
                    showBulletsOnDesktop
                    hideArrows
                  />
                </li>
              }
            </Fragment>
          );
        })
      }
      {(isWinnerPage && link) && <GoToListBtn link={`${link}/leaderboard`}>Весь рейтинг</GoToListBtn>}

      {isPairCompareWidget &&  <GoToListBtn link='/ratings'>Хочу еще</GoToListBtn>}
      <scope.styles />
    </ol>
  );
}

List.propTypes = {
  variants: PropTypes.array,
  active: PropTypes.number,
  isWinnerPage: PropTypes.bool,
  topics: PropTypes.arrayOf(modelPropTypes(topicAttributes)),
  link: PropTypes.string,
  startIndex: PropTypes.number,
  widgetType: PropTypes.string,
  isOdd: PropTypes.bool,
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          leaderBoard: {
            table: {
              borderColor,
              background,
              activeBackground,
            },
            count: {
              background,
              font,
              color,
              activeBackground,
              activeColor,
            },
            header: {
              color,
              font,
              questionBackground,
              questionFill,
            },
          }
        }
      },
    },
  `),
};

export default withTheme(List);
